export default __webpack_public_path__ + "static/media/logo-2.5fdffa34.png";